import { createContext } from 'react';

import type { TeamCalendarState } from '@app/providers/CalendarProvider/TeamCalendarContext.types';

export const TeamCalendarContext = createContext<TeamCalendarState>({
  employeeDetails: [],
  setEmployeeDetails: () => {},
  selectedEmployees: [],
  setSelectedEmployees: () => {},
  allEmployees: [],
  setAllEmployees: () => {},
  lastStoredEmployeeDetails: [],
  setLastStoredEmployeeDetails: () => {},
  branchWorkingHoursForDate: { WorkTimeS: '', WorkTimeE: '' },
  setBranchWorkingHoursForDate: () => {},
  financialStatistics: undefined,
  setFinancialStatistics: () => {},
});
